import { isTruthy } from 'utils';

import { Attribute } from '@/modules/product/api/singleProduct';

import { isInductionStoveType, technicalIconsSrc } from './utils';

export function renderTechnicalIcon(
  index: number,
  icon: Attribute,
  attributes: Attribute[],
  className: string
) {
  let value;

  switch (icon.slug) {
    case 'technical_icons_8':
      const dashwasher = attributes.find(
        (attribute: Attribute) => attribute.slug === 'dishwasher'
      );

      if (isTruthy(dashwasher?.values[0]) === true) {
        value = '1';
      } else if (isTruthy(dashwasher?.values[0]) === false) {
        value = '0';
      }

    case 'technical_icons_12':
      const stoveType = attributes.find(
        (attribute: Attribute) => attribute.slug === 'stove_type'
      );

      if (stoveType?.values) {
        value = isInductionStoveType(stoveType?.values) ? '1' : '0';
      }

    default:
      if (icon.values.includes('1')) {
        value = '1';
      }
  }

  const Icon = technicalIconsSrc[`${icon.slug}_${value}`];

  if (!Icon) {
    return;
  }

  const nameHtml = icon.name.replace(/\s([a-z]{1})\s(.*?)/g, ' $1&nbsp;');

  return (
    <div className={className} key={index}>
      <Icon />
      <span dangerouslySetInnerHTML={{ __html: nameHtml }}></span>
    </div>
  );
}
